import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Button, Divider, Flex, Text } from 'pcln-design-system'
import { ChevronDown, User } from 'pcln-icons'
import DropdownPopover from '../DropdownPopover'

const StyledPopover = styled(DropdownPopover)`
  width: auto;
  max-width: none;

  & > section {
    & > :first-child {
      & > :first-child {
        padding: ${themeGet('space.3')}px;
      }
    }
  }
`

const StyledFlex = styled(Flex)`
  cursor: pointer;
`

const CenteredText = styled(Text)`
  display: flex;
  align-items: center;
  white-space: nowrap;
`

const LeftButton = styled(Button)`
  text-align: left;
`

const StyledDivider = styled(Divider)`
  margin-top: ${themeGet('space.3')}px;
`

function SignedIn ({
  className,
  color,
  firstName,
  points,
  pointsName,
  membershipName,
  membershipNumber,
  onLogoutClicked
}) {
  const PopoverContent = (
    <Content
      points={points}
      pointsName={pointsName}
      membershipName={membershipName}
      membershipNumber={membershipNumber}
      onLogoutClicked={onLogoutClicked}
    />
  )

  return (
    <StyledPopover className={className} content={PopoverContent}>
      <StyledFlex alignItems='center'>
        <User color={color} mr={2} />
        <CenteredText color={color}>
          Hi, {firstName}
          <ChevronDown />
          {points && `| ${points} ${pointsName}`}
        </CenteredText>
      </StyledFlex>
    </StyledPopover>
  )
}

function Content ({
  points,
  pointsName,
  membershipName,
  membershipNumber,
  onLogoutClicked
}) {
  return (
    <Flex flexDirection='column'>
      <Flex>
        <Text fontSize={1} bold mr={1}>
          {membershipName}:
        </Text>
        <Text fontSize={1}>{membershipNumber}</Text>
      </Flex>
      {points && (
        <Flex>
          <Text fontSize={1} bold mr={1}>
            {pointsName}:
          </Text>
          <Text fontSize={1}>{points}</Text>
        </Flex>
      )}
      <StyledDivider />
      <LeftButton variation='link' onClick={onLogoutClicked} mt={2}>
        Sign out
      </LeftButton>
    </Flex>
  )
}

SignedIn.displayName = 'SignedIn'

SignedIn.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  firstName: PropTypes.string,
  points: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pointsName: PropTypes.string,
  membershipName: PropTypes.string,
  membershipNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onLogoutClicked: PropTypes.func
}

export default memo(SignedIn)
